(ns quuppa.ui.dropdown
  (:require [reagent.core :as r]
            [quuppa.ui.icons :refer [icon]]
            ["react-bootstrap/Dropdown$default" :as Dropdown]
            ["react-bootstrap/DropdownButton$default" :as DropdownButton]))

(def dropdown (r/adapt-react-class Dropdown))
(def toggle (r/adapt-react-class (.-Toggle Dropdown)))
(def menu (r/adapt-react-class (.-Menu Dropdown)))
(def item (r/adapt-react-class (.-Item Dropdown)))

(def dropdown-button
  "From react-bootstrap docs:

  'Since the above (Dropdown as wrapper, Dropdown.Toggle as toggle button) is such a common configuration
   react-bootstrap provides the <DropdownButton> component to help reduce typing.
   Provide a title prop and some <DropdownItem>s and you're ready to go.'
  "
  (r/adapt-react-class DropdownButton))

(defn menu-icon-toggle
  "Dropdown toggle button with just three-dot icon. Square.

  Bootstrap caret is disabled from SASS ($enable-caret: false)."
  ([]
   [menu-icon-toggle nil])
  ([{:keys [class title disabled]}]
   [toggle
    {:variant  "default"
     :disabled disabled
     :class    (str "btn-square " class)}
    [icon :three-dots-vertical
     {:title (or title "Menu")}]]))
